import { useStore } from 'vuex'

export default [
    {
		path: '/',
		name: 'Root',
		component: () => import('@/views/auth/Root.vue'),
		meta: {
			layout: 'Auth',
		}
	},
    {
		path: '/auto-version',
		name: 'AutoVersion',
		component: () => import('@/views/auth/AutoVersion.vue'),
		meta: {
			layout: 'Auth',
			abilities: [['*']],
		}
	},
    {
		path: '/login/:version?',
		name: 'Login',
		component: () => import('@/views/auth/Login.vue'),
		props: route => ({ 
			version: route.params.version == 'v2' ? 2 : (route.params.version == 'v1' ? 1 : null), 
		}),
		meta: {
			layout: 'Auth',
		}
	},
    {
		path: '/plugin-authed',
		name: 'Plugin Authenticated',
		component: () => import('@/views/auth/PluginAuthed.vue'),
		props: route => ({ workspace: route.params.workspace }),
		meta: {
			layout: 'Auth',
		}
	},
	{
		path: '/reset-password',
		name: 'Reset Password',
		component: () => import('@/views/auth/ResetPassword.vue'),
		meta: {
			layout: 'Auth',
		}
	},
	{
		path: '/forgot-password',
		name: 'Forgot Password',
		component: () => import('@/views/auth/ForgotPassword.vue'),
		meta: {
			layout: 'Auth',
		}
	},
    {
		path: '/forgot-password/success',
		name: 'success password',
		component: () => import('@/views/auth/SuccessPage.vue'),
		meta: {
			layout: 'Auth',
		}
	},
	{
		path: '/workspaces',
		name: 'Find Workspace',
		component: () => import('@/views/auth/WorkspaceList.vue'),
		meta: {
			layout: 'Auth',
			abilities: [['*']],
		}
	},
	{
		path: '/finder/:version?',
		name: 'Workspace Finder',
		component: () => import('@/views/team/WorkspaceSelect.vue'),
		props: route => ({
			version: route.params.version == 'v2' ? 2 : (route.params.version == 'v1' ? 1 : (route.params.version ?? 'auto')), 
		}),
		meta: {
			layout: 'Auth',
			abilities: [['*']],
		}
	},
	{
		path: '/v1/go',
		name: 'v1 redirect',
		component: () => import('@/views/team/WorkspaceV1Redirect.vue'),
		meta: {
			layout: 'Auth',
			abilities: [['*']],
		}
	},
	{
		path: '/v2/go',
		name: 'v2 redirect',
		component: () => import('@/views/team/WorkspaceV2Redirect.vue'),
		meta: {
			layout: 'Auth',
			abilities: [['*']],
		}
	},
	{
		path: '/confirm-email',
		name: 'Confirm Email',
		component: () => import('@/views/auth/ConfirmEmail.vue'),
		meta: {
			layout: 'Auth',
			abilities: [['*']],
		}
	},
	{
		path: '/join',
		name: 'Join Workspace',
		component: () => import('@/views/auth/JoinWorkspace.vue'),
		meta: {
			layout: 'Auth',
			abilities: [['*']],
		}
	}
]